import React, {useState} from 'react'
import BoldTypography from "components/BoldTypography";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import GridBlock from "components/GridBlock";
import Typography from "components/Typography";
import Tr from "translations/Translations";
import clsx from "clsx";

const useStyle = makeStyles(theme => ({
    root: {
        borderBottom: "solid 1px",
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing()
    },
    titleRoot: {
        '&>*:nth-child(1)': {
            flexGrow: 1
        }
    },
    titleCollapsible: {
        cursor: "pointer"
    },
    content: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    label: {
        fontSize: '1.1rem'
    }

}))

function GeneralInfoEntry(
    {
        label,
        collapsible = false,
        defaultCollapsed,
        biggerLabel = false,
        children
    }) {
    const classes = useStyle();

    const [collapsed, setCollapsed] = useState(defaultCollapsed === undefined ? collapsible : defaultCollapsed);

    return <div className={classes.root}>
        <GridBlock className={clsx(classes.titleRoot, {[classes.titleCollapsible]: collapsible})}
                   onClick={collapsible ? () => setCollapsed(x => !x) : undefined}>
            <BoldTypography className={clsx({[classes.label]: biggerLabel})}>{label}</BoldTypography>
            {(collapsible) && <Typography>{Tr(collapsed ? 'expand' : 'collapse')}</Typography>}
        </GridBlock>
        {!collapsed && <div className={classes.content}>{children}</div>}
    </div>

}

GeneralInfoEntry.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    collapsible: PropTypes.bool
}

export default GeneralInfoEntry;